import {detectAndroidBrand, isAndroid, isIOS, isWeiXinOrQQ} from "../../../library/util/userAgentUtil";

export function toAiPage() {
    window.open("/coralreef/ai/compose", "_blank")
}

export function isOfficialHomePage(): boolean {
    console.log(window.location.pathname)
    return window.location.pathname == "/"
}

export function toIosDownloadPage() {
    window.open("https://apps.apple.com/cn/app/%E7%8F%8A%E7%91%9A%E7%A4%81/id6482988054", "_blank")
}

export function getAndroidAppLink(): string {
    let miLink = "https://app.mi.com/details?id=com.coralplanets.coralreef"
    let huaweiLink = "https://appgallery.huawei.com/app/C110554965"
    let vivoLink = "https://h5.appstore.vivo.com.cn/#/details?search_word=%E7%8F%8A%E7%91%9A%E7%A4%81&search_action=4&app_id=3728812&app_pos=1&source=5&appId=3728812&frompage=searchResultApp&listpos=1"

    let androidBrand = detectAndroidBrand()
    if (androidBrand == "xiaomi") return miLink
    if (androidBrand == "huawei") return huaweiLink
    if (androidBrand == "vivo") return vivoLink

    // 荣耀与oppo无网页版
    return ""
}

export function toAndroidDownloadPage() {
    let appLink = getAndroidAppLink()
    if (appLink) {
        window.open(appLink, "_blank")
        return
    }
    // 浏览器直接下载apk包
    window.open("https://static.coralplanets.com/static/coralplanets-v2.0.5.apk", "_blank")
}

export function downloadTrigger(showBrowserHint: () => void) {
    // 微信环境下，显示打开浏览器提示
    if (isWeiXinOrQQ()) {
        showBrowserHint()
        return
    }

    if (isIOS()) {
        toIosDownloadPage()
        return
    }
    if (isAndroid()) {
        toAndroidDownloadPage()
        return
    }
    window.location.href = "/download"
}